// extracted by mini-css-extract-plugin
export default {"wrapper":"fEa4e","title":"Lmy9a","title--left":"q3bnX","input":"IUJI1"};